<template>
  <div class="channel-statistics">
    <div class="tuolele-main-box">
      <div class="form-row">
        <div class="form-input fn-clear">
          <span class="fn-left">选择店铺</span>
          <div class="shop-select">
            <ShopSelect :init="init" @updateShop="updateShop" />
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="form-input fn-clear">
          <span class="fn-left">选择时间</span>
          <el-date-picker
            v-model="filterObj.begin_time"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="开始日期"
          />
          <i>至</i>
          <el-date-picker
            v-model="filterObj.end_time"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="结束日期"
          />
          <div
            class="calendar-btn"
            :class="{ active: filterObj.search_calendar == 1 }"
            @click="changeCalendar"
          >
            只看工作日
          </div>
          <el-button type="primary" @click="searchData">查询</el-button>
        </div>
      </div>
    </div>
    <div>
      <Tablist
        :list.sync="tabList"
        :active-id="activeIndex"
        @updateCurrentPage="updateCurrentPage"
      />
      <div class="tuolele-main-box">
        <div v-if="activeIndex == 0" class="total">
          <Total :total-data.sync="totalData" />
        </div>
        <div v-else-if="activeIndex == 1" class="table">
          <Table :data-info.sync="dataInfo" />
        </div>
        <div v-else class="compare">
          <Compare :data-info.sync="dataInfo" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ShopSelect from '@/components/toolbar/ShopSelect.vue'
import Tablist from '@/components/toolbar/Tablist.vue'
import Total from '@/components/statistics/channelStatistics/Total.vue'
import Table from '@/components/statistics/channelStatistics/Table.vue'
import Compare from '@/components/statistics/channelStatistics/Compare.vue'
import Tool from '@/assets/js/tool.js'
export default {
  name: 'ChannelStatistics',
  components: {
    ShopSelect,
    Tablist,
    Table,
    Compare,
    Total
  },
  props: [''],
  data() {
    return {
      filterObj: {
        begin_time: '',
        end_time: '',
        shop_id: '',
        search_calendar: '',
        key:
          'A10,B11,C7,D7,A11,B12,C8,D8,A12,B13,C9,D9,A13,B14,C10,D10,A14,B15,C11,D11,A15,B16,C12,D12'
      },
      tabList: [
        { id: '0', directory_name: '总览数据' },
        { id: '1', directory_name: '详细数据' },
        { id: '2', directory_name: '店铺对比数据' }
      ],
      activeIndex: '0',
      init: true,
      dataInfo: [],
      totalData: {},
      priceKeys: ['D7', 'D8', 'D9', 'D10', 'D11', 'D12']
    }
  },
  computed: {},
  watch: {},
  mounted() {
    this.filterObj.begin_time = Tool.formatTime(
      new Date() - 86400 * 1000 * 30,
      'date'
    )
    this.filterObj.end_time = Tool.formatTime(new Date(), 'date')
  },
  methods: {
    async getDataForShop(filterObj) {
      const ret = await this.$http.getDataForShop(filterObj)
      const me = this
      if (ret.code == 200) {
        const dataInfo = ret.data.shop_data
        dataInfo.unshift({
          shop_name: '总和',
          result: ret.data.total_data
        })
        dataInfo.forEach(e => {
          const keys = me.filterObj.key.split(',')
          keys.forEach(ele => {
            e[ele] = e.result[ele]
          })
          me.priceKeys.forEach(ele => {
            e[ele] = e[ele] / 100
          })
        })
        this.dataInfo = dataInfo
        this.totalData = dataInfo[0]
      }
    },
    changeCalendar() {
      if (this.filterObj.search_calendar == 1) {
        this.filterObj.search_calendar = 0
      } else {
        this.filterObj.search_calendar = 1
      }
    },
    updateShop(val) {
      this.filterObj.shop_id = val.join(',')
      if (this.init) {
        this.init = false
        this.getDataForShop(this.filterObj)
      }
    },
    searchData() {
      this.getDataForShop(this.filterObj)
    },
    updateCurrentPage(val) {
      this.activeIndex = val
    }
  }
}
</script>
<style lang="scss" scoped>
.channel-statistics {
  .form-row {
    .form-input {
      .el-button {
        width: 90px;
        height: 40px;
        margin-left: 20px;
      }
      .calendar-btn {
        display: inline-block;
        width: 150px;
        height: 40px;
        border-radius: 6px;
        border: solid 1px #ebebeb;
        vertical-align: middle;
        margin-left: 20px;
        text-align: center;
        line-height: 40px;
        font-size: 14px;
        cursor: pointer;
        &.active {
          border-color: $color_blue;
          color: $color_blue;
        }
      }
      > i {
        font-style: normal;
        margin: 0 10px;
      }
    }
  }
}
</style>
